export default __webpack_public_path__ + "static/media/telephone.d568076d.svg";